export const GRAPHQL_HOST = process.env.REACT_APP_GRAPHQL_HOST || 'http://localhost:4000';
export const RWV1_HOST = process.env.REACT_APP_RWV1_HOST || 'https://stage.researchworkspace.com';
